(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
class CarouselSection {
  constructor(container) {
    this.container = container;
    this.swiper = null;
    this.initAttempts = 0;
    this.maxAttempts = 10;
    this.init();
  }

  init() {
    // Check if Swiper is loaded
    if (typeof Swiper === 'undefined') {
      console.log('Swiper not loaded yet, retrying...');
      this.retryInit();
      return;
    }

    console.log('Swiper is available:', typeof Swiper, Swiper);
    console.log('Swiper constructor:', Swiper);

    const swiperContainer = this.container.querySelector('.carousel-swiper');
    if (!swiperContainer) {
      console.error('Swiper container not found');
      return;
    }

    console.log('Initializing Swiper carousel...');
    console.log('Container element:', swiperContainer);
    console.log('Container classes:', swiperContainer.className);

    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    const slides = swiperWrapper.querySelectorAll('.swiper-slide');
    // If exactly two slides, duplicate both to make min 5 (loop works better for slide per view = 1.1)
    if (slides?.length >= 3 || slides?.length < 5) {
      slides.forEach((slide, index) => {
        swiperWrapper.appendChild(slide.cloneNode(true));
      });
    }
    // // If only one slide, duplicate it a few times
    // if (slides.length === 1) {
    //   const clone1 = slides[0].cloneNode(true);
    //   const clone2 = slides[0].cloneNode(true);
    //   const clone3 = slides[0].cloneNode(true);
    //   swiperWrapper.appendChild(clone1);
    //   swiperWrapper.appendChild(clone2);
    //   swiperWrapper.appendChild(clone3);
    // }

    // Add custom styles for Swiper elements that can't be styled with Tailwind
    this.addCustomStyles();

    try {
      console.log('About to create new Swiper instance...');
      console.log('Swiper constructor type:', typeof Swiper);
      console.log('Swiper constructor:', Swiper);
      console.log('Swiper container element:', swiperContainer);
      console.log('Swiper container HTML:', swiperContainer.outerHTML);
      
      // Try using Swiper constructor first
      if (typeof Swiper === 'function') {
        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 24,
          centeredSlides: true,
          loop: slides?.length >= 3,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: this.container.querySelector('.carousel-button-next'),
            prevEl: this.container.querySelector('.carousel-button-prev'),
          },
          pagination: {
            el: this.container.querySelector('.carousel-pagination'),
            clickable: true,
          },
          on: {
            init: () => {
              console.log('Swiper carousel initialized successfully');
              this.container.classList.add('carousel-initialized');
            },
            beforeInit: () => {
              console.log('Swiper carousel initializing...');
            },
          },
        });
        
        console.log('Swiper instance created:', this.swiper);
      } else {
        console.log('Swiper constructor not available, trying alternative methods...');
        throw new Error('Swiper constructor not available');
      }
    } catch (error) {
      console.error('Error initializing Swiper:', error);
      console.error('Error stack:', error.stack);
      
      // Fallback: try to use Swiper element if available
      if (typeof window.SwiperElement !== 'undefined') {
        console.log('Trying SwiperElement fallback...');
        try {
          // Convert to Swiper element
          const swiperElement = document.createElement('swiper-container');
          swiperElement.setAttribute('slides-per-view', '1');
          swiperElement.setAttribute('space-between', '24');
          swiperElement.setAttribute('loop', 'true');
          
          // Copy slides
          const slides = swiperContainer.querySelectorAll('.swiper-slide');
          slides.forEach(slide => {
            const slideElement = document.createElement('swiper-slide');
            slideElement.innerHTML = slide.innerHTML;
            swiperElement.appendChild(slideElement);
          });
          
          // Replace the container
          swiperContainer.parentNode.replaceChild(swiperElement, swiperContainer);
          console.log('Converted to Swiper element');
        } catch (fallbackError) {
          console.error('SwiperElement fallback also failed:', fallbackError);
        }
      }
    }
  }

  retryInit() {
    if (this.initAttempts >= this.maxAttempts) {
      console.error('Failed to initialize Swiper after maximum attempts');
      return;
    }

    this.initAttempts++;
    setTimeout(() => {
      this.init();
    }, 100 * this.initAttempts); // Exponential backoff
  }

  addCustomStyles() {
    // Add minimal custom styles for Swiper elements that can't be styled with Tailwind
    const style = document.createElement('style');
    style.textContent = `
      .carousel-swiper {
        --swiper-theme-color: #3b82f6;
        --swiper-pagination-bullet-size: 20px;
        --swiper-pagination-bullet-horizontal-gap: 8px;
      }

      .carousel-pagination{
        display: flex;
        gap: var(--swiper-pagination-bullet-horizontal-gap);
        align-items: center;
        justify-content: center;
      }

      .carousel-pagination .swiper-pagination-bullet {
        width: var(--swiper-pagination-bullet-size) !important;
        height: var(--swiper-pagination-bullet-size) !important;
        border: 2px solid #fff !important;
        background: transparent !important;
        opacity: 1 !important;
        margin: 0 !important;
        border-radius: 9999px !important; /* rounded-full */
        box-sizing: border-box !important;
        transition: all 300ms ease-in-out;
      }

      .carousel-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
        background: #fff !important;
        border-color: #fff !important;
      }

      @media (max-width: 768px) {
        .carousel-swiper {
          --swiper-pagination-bullet-size: 14px;
        }
      }
    `;
    this.container.appendChild(style);
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

// Function to initialize carousels
function initializeCarousels() {
  console.log('Looking for carousel sections...');
  const carouselSections = document.querySelectorAll('[data-section-id]');
  console.log(`Found ${carouselSections.length} sections with data-section-id`);
  
  carouselSections.forEach((section, index) => {
    console.log(`Section ${index}:`, section);
    console.log(`Section data-section-id:`, section.getAttribute('data-section-id'));
    console.log(`Section classes:`, section.className);
    
    const swiperContainer = section.querySelector('.carousel-swiper');
    if (swiperContainer) {
      console.log(`Found carousel section ${index}, initializing...`);
      console.log('Swiper container:', swiperContainer);
      console.log('Swiper container classes:', swiperContainer.className);
      
      try {
        const carousel = new CarouselSection(section);
        // Store the carousel instance on the section element
        section.carouselInstance = carousel;
        console.log(`Carousel ${index} initialized successfully`);
      } catch (error) {
        console.error(`Error initializing carousel ${index}:`, error);
      }
    } else {
      console.log(`Section ${index} is not a carousel section`);
    }
  });
}

// Initialize carousels when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, checking for Swiper...');
  console.log('Global Swiper object:', window.Swiper);
  console.log('typeof Swiper:', typeof Swiper);
  
  // Check if Swiper script is already loaded
  const swiperScript = document.querySelector('script[src*="swiper"]');
  if (swiperScript) {
    console.log('Found Swiper script tag:', swiperScript);
    console.log('Script src:', swiperScript.src);
    console.log('Script loading state:', swiperScript.readyState);
    
    // Check if script is already loaded
    if (swiperScript.readyState === 'complete' || swiperScript.readyState === 'loaded') {
      console.log('Swiper script already loaded');
      if (typeof Swiper !== 'undefined') {
        console.log('Swiper available, initializing carousels...');
        initializeCarousels();
      } else {
        console.log('Swiper script loaded but Swiper object not available');
      }
    } else {
      console.log('Swiper script still loading, adding load listener');
      swiperScript.addEventListener('load', () => {
        console.log('Swiper script load event fired');
        setTimeout(() => {
          if (typeof Swiper !== 'undefined') {
            console.log('Swiper available after script load event');
            initializeCarousels();
          } else {
            console.log('Swiper still not available after load event');
          }
        }, 100);
      });
    }
  } else {
    console.log('No Swiper script tag found');
  }
  
  if (typeof Swiper !== 'undefined') {
    console.log('Swiper already available, initializing carousels...');
    initializeCarousels();
  } else {
    console.log('Swiper not available yet, waiting...');
    // Wait for Swiper to load
    const checkSwiper = setInterval(() => {
      if (typeof Swiper !== 'undefined' || typeof window.Swiper !== 'undefined') {
        console.log('Swiper now available, initializing carousels...');
        clearInterval(checkSwiper);
        initializeCarousels();
      }
    }, 100);
    
    // Also check for script load event
    if (swiperScript) {
      swiperScript.addEventListener('load', () => {
        console.log('Swiper script loaded');
        if (typeof Swiper !== 'undefined') {
          console.log('Swiper available after script load');
          clearInterval(checkSwiper);
          initializeCarousels();
        }
      });
    }
  }
});

// Handle Shopify section events
document.addEventListener('shopify:section:load', (event) => {
  console.log('Shopify section loaded:', event.target);
  const section = event.target;
  if (section.querySelector('.carousel-swiper')) {
    console.log('New carousel section loaded, initializing...');
    const carousel = new CarouselSection(section);
    // Store the carousel instance on the section element
    section.carouselInstance = carousel;
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target;
  if (section.carouselInstance) {
    console.log('Destroying carousel instance...');
    section.carouselInstance.destroy();
    delete section.carouselInstance;
  }
});

  } catch(e) { console.error(e); }
})();
})();
